import React, { createContext, useContext, useEffect, useState } from "react";
import { auth } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await auth.me();
      setUser(data.user);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const loginDev = async (email, name) => {
    const { data } = await auth.devLogin(email, name);
    if (data.token) localStorage.setItem("wxs_token", data.token);
    setUser(data.user);
  };

  const loginGoogle = async (credential) => {
    const { data } = await auth.google(credential);
    if (data.token) localStorage.setItem("wxs_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    await auth.logout().catch(() => {});
    localStorage.removeItem("wxs_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, loginDev, loginGoogle, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
